import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './TrainingScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import * as TrainingActions from '../../actions/TrainingActions';
import FilterScreen from './FilterScreen/FilterScreen';
import TableScreen from './TableScreen/TableScreen';
import { Modal, Button, Spin, Table } from 'antd';
import { Grid } from '@material-ui/core';
import TextInput from '../../../app/components/TextInput';
import ModalAssignation from './ModalAssignation/ModalAssignation';

const TrainingScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [visibleModal, setVisibleModal] = useState(false);
    const [visibleModalAssign, setVisibleModalAssign] = useState(false);
    const [idTraining, setIdTraining] = useState('');
    const [trainingName, setTrainingName] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [FiltroNombre, setFiltroNombre] = useState([]);
    const { confirm } = Modal;
    const { siteId } = useSelector(state => state.Auth)

    const {
        isSaveRecord,
        pagination,
        filter,
        listTraining
    } = useSelector(state => state.TrainingReducer);

    const submit = () => {
        dispatch(TrainingActions.insUpdTraining({
            idTraining: idTraining,
            trainingName: trainingName
        }, updateTable));
    }

    const assignManage = (record) => {
        dispatch(TrainingActions.getEmployeeAdmin());
        dispatch(TrainingActions.getEmployeeAdminId(record.idTraining, (data) => {
            setSelectedRowKeys(data);
        }));

        setIdTraining(record.idTraining);
        setTrainingName(record.trainingName);
        setVisibleModalAssign(true);
    }

    const updateTable = () => {
        dispatch(TrainingActions.fetchTraining({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listIdTraining: filter.listNames.length > 0 ? filter.listNames.join(",") : undefined,
            listSubdirection: filter.listSubdirections.length > 0 ? filter.listSubdirections.join(",") : undefined
        }));
        setVisibleModal(false);
        dispatch(TrainingActions.getNames());
        dispatch(TrainingActions.getSubdirections());
    }

    const showConfirmDelete = (data) => {
        confirm({
            title: '¿Eliminar Tipo de Capacitación?',
            content: data.trainingName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(TrainingActions.deleteTraining(data, () => {
                    if (pagination.current !== 1 && listTraining.length === 1) {
                        pagination.current = pagination.current - 1;
                    }

                    let obj = {
                        listNames: filter.listNames.filter(x => x !== data.idTraining),
                        listSubdirections: filter.listSubdirections
                    }

                    dispatch(TrainingActions.saveFilter(obj));

                    dispatch(TrainingActions.clear());
                    dispatch(TrainingActions.fetchTraining({
                        offset: (pagination.current - 1) * pagination.pageSize,
                        limit: pagination.pageSize,
                        sortColumn: pagination.column,
                        sortDir: pagination.order,
                        listIdTraining: filter.listNames.filter(x => x !== data.idTraining).length > 0 ? filter.listNames.filter(x => x !== data.idTraining).join(",") : undefined,
                        listSubdirection: filter.listSubdirections.length > 0 ? filter.listSubdirections.join(",") : undefined
                    }));
                    dispatch(TrainingActions.getNames());
                    dispatch(TrainingActions.getSubdirections());
                }))
            },
            onCancel() { },
        });

    }

    const newTraining = () => {
        setIdTraining('');
        setTrainingName('');
        setVisibleModal(true);
    }

    const editTraining = (record) => {
        setIdTraining(record.idTraining);
        setTrainingName(record.trainingName);
        setVisibleModal(true);
    }

    useEffect(() => {
        dispatch(TrainingActions.clear());
        dispatch(TrainingActions.fetchTraining({
            offset: 0,
            limit: 25
        }))
        dispatch(TrainingActions.getNames());
        dispatch(TrainingActions.getSubdirections());
    }, [dispatch]);

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isCatalog={true} header=' Tipo de Capacitación' isCommunicationStatus={false} />
            <CssBaseline />

            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                            Catálogos
                        </Link>
                        <TextEvents
                            text="Catálogo de Tipos de Capacitación"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>

                    <Paper className={classes.rootPaper}>
                        <FilterScreen
                            newTraining={newTraining}
                            FiltroNombre={FiltroNombre}
                            setFiltroNombre={setFiltroNombre}
                        />
                        <TableScreen
                            editTraining={editTraining}
                            showConfirmDelete={showConfirmDelete}
                            assignManage={assignManage}
                            FiltroNombre={FiltroNombre}
                            setFiltroNombre={setFiltroNombre}
                        />

                        {
                            visibleModal ?
                                <Modal
                                    destroyOnClose={true}
                                    onCancel={() => setVisibleModal(false)}
                                    visible={visibleModal}
                                    title={<TextEvents
                                        text={idTraining === '' ? 'Nuevo Tipo de Capacitación' : (siteId === "HUB" ? 'Editar' : 'Visualizar') + ' Tipo de Capacitación'}
                                        color='cotemar'
                                        size='label'
                                        weight='bold'
                                    />}
                                    width={'650px'}
                                    centered={true}
                                    footer={
                                        [
                                            <Button key="back" type="danger" ghost onClick={() => setVisibleModal(false)}>
                                                Cancelar
                                            </Button>,
                                            siteId === "HUB" ?
                                                <Button disabled={trainingName === '' || (idTraining !== '' && trainingName === listTraining.find(x => x.idTraining === idTraining).trainingName)} key="submit" type="primary" loading={false} onClick={() => submit()}>
                                                    Guardar
                                                </Button> : null
                                        ]
                                    }
                                >
                                    <Spin spinning={isSaveRecord}>
                                        <Grid container direction="row">
                                            <Grid item xs={12}>
                                                <TextInput
                                                    value={trainingName}
                                                    setValue={setTrainingName}
                                                    text='Nombre del Tipo de Capacitación:'
                                                    color='darker'
                                                    size='label'
                                                    weight='medium'
                                                    mode='input'
                                                    placeholder='Nombre'
                                                    disabled={siteId === "HUB" ? "" : "disabled"}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Spin>
                                </Modal> : null
                        }

                        {
                            <ModalAssignation
                                visibleModalAssign={visibleModalAssign}
                                setVisibleModalAssign={setVisibleModalAssign}
                                idTraining={idTraining}
                                trainingName={trainingName}
                                selectedRowKeys={selectedRowKeys}
                                setSelectedRowKeys={setSelectedRowKeys}
                            />
                        }
                    </Paper>
                </div>
            </div>
        </div>
    )
}

export default TrainingScreen;